module.exports = __webpack_public_path__ + "img/Mauritania.eefe1b6f.png";